<template lang="">
  <UserLayout pageTitle="Gestione risorse">
    <template #page-content="props">
      <v-card>
        <v-container class="pa-8">
          <v-tabs vertical>
            <v-tab class="vertical_tabs">
              <v-icon left> mdi-account-group </v-icon>
              <span class="tab-text">workers</span>
            </v-tab>
            <v-tab class="vertical_tabs">
              <v-icon left> mdi-car-estate </v-icon>
              <span class="tab-text">vehicles</span>
            </v-tab>
            <v-tab class="vertical_tabs">
              <v-icon left> mdi-cog </v-icon>
              <span class="tab-text">Instruments</span>
            </v-tab>

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <FrmManageWorkers></FrmManageWorkers>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <FrmManageVehicles></FrmManageVehicles>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <FrmManageEquipments></FrmManageEquipments>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>

          <!-- <v-divider></v-divider>
                              <template>
                      <v-btn color="error" class="mt-2" :to="{ name: 'dashboard' }">
                        Indietro
                      </v-btn>
                    </template> -->
        </v-container>
      </v-card>
    </template>
  </UserLayout>
</template>
<script>
import UserLayout from "../layout/UserLayout";
import FrmManageWorkers from "../components/Management/FrmManageWorkers";
import FrmManageEquipments from "../components/Management/FrmManageEquipments";
import FrmManageVehicles from "../components/Management/FrmManageVehicles";
import SessionHelper from "../utils/SessionHelper";
export default {
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
    this.checkIfMobile();

    window.addEventListener("resize", this.checkIfMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIfMobile);
  },
  methods: {
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
  components: {
    FrmManageWorkers,
    FrmManageEquipments,
    FrmManageVehicles,
    UserLayout,
  },
};
</script>
<style scoped>
@media (max-width: 768px) {
  .tab-text {
    display: none;
  }
}
</style>
